import { BaseModal } from "./BaseModal";
import { shareStatus } from "../../lib/share";
import { ShareIcon, ChartBarIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";
import { VerseTextWithSolution } from "./VerseTextWithSolution";

import { verseText, verse, verseUrl, solution } from "../../lib/words";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  guesses: string[];
  isGameLost: boolean;
  isGameWon: boolean;
  handleShareToClipboard: () => void;
  isHardMode: boolean;
  isDarkMode: boolean;
  isHighContrastMode: boolean;
  numberOfGuessesMade: number;
};

export const ScriptureModal = ({
  isOpen,
  handleClose,
  guesses,
  isGameLost,
  handleShareToClipboard,
  isHardMode,
  isDarkMode,
  isHighContrastMode,
}: Props) => {
  const navigate = useNavigate();

  return (
    <BaseModal title={"Solution: " + solution} isOpen={isOpen} handleClose={handleClose}>
      <div className="mt-3 text-sm dark:text-white">
        <div className="text-center mb-2">
          <a
            href={verseUrl}
            target="_blank"
            className="underline font-bold text-blue-700"
            rel="noreferrer"
          >
            {verse}
          </a>
        </div>
        <div className="text-center mx-auto max-w-md leading-relaxed">
          &quot;<VerseTextWithSolution verseText={verseText} solution={solution} />&quot;
        </div>
      </div>
      <div className="mt-5 flex justify-center gap-6">
        <button
          type="button"
          className="flex items-center justify-center w-20 h-12 rounded-md bg-blue-600 border border-blue-600 shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={() => {
            shareStatus(
              guesses,
              isGameLost,
              isHardMode,
              isDarkMode,
              isHighContrastMode,
              handleShareToClipboard
            );
          }}
          aria-label="Share Score"
        >
          <ShareIcon className="h-6 w-6 text-white" />
        </button>
        <button
          type="button"
          className="flex items-center justify-center w-20 h-12 rounded-md bg-white border border-gray-200 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-600"
          onClick={() => {
            handleClose();
          }}
          aria-label="See Stats"
        >
          <ChartBarIcon className="h-6 w-6 text-indigo-600" />
        </button>
      </div>
      <hr className="mt-4 mb-3 mx-auto max-w-md border-gray-200 dark:border-gray-600" />
      <div className="flex justify-center items-center gap-8 text-sm">
        <a
          href="https://hymnle.com"
          target="_blank"
          className="underline font-bold text-blue-700"
          rel="noreferrer"
          tabIndex={-1}
        >
          Play Hymnle
        </a>
        <span className="text-gray-300 dark:text-gray-600">|</span>
        <button
          className="underline font-bold text-blue-700"
          onClick={() => {
            handleClose();
            navigate('/practice');
          }}
          tabIndex={-1}
        >
          Endless Mode
        </button>
      </div>
    </BaseModal>
  );
};
